import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_MAIN_URL as API_URL } from "../config";

const useWhatsAppLink = () => {
    const [whatsappUrl, setWhatsappUrl] = useState("");
    const [qrCodeBase64, setQrCodeBase64] = useState("");
    const [linkingCode, setLinkingCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [timeRemaining, setTimeRemaining] = useState(0);
    const [expiresAt, setExpiresAt] = useState(0);
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const generateLink = useCallback(async () => {
        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `${API_URL}/api/whatsapp/generate-link`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "X-User-ID": localStorage.getItem("userId") || "anonymous",
                    },
                }
            );

            if (response.data.success && response.data.whatsapp_url && Number.isFinite(response.data.expires_in_seconds)) {
                setWhatsappUrl(response.data.whatsapp_url);
                setQrCodeBase64(response.data.qr_code_base64);
                setLinkingCode(response.data.token);
                setTimeRemaining(response.data.expires_in_seconds);
                setExpiresAt(Date.now() + response.data.expires_in_seconds * 1000);
            } else {
                throw new Error('Invalid WhatsApp link response');
            }
        } catch (err) {
            console.error("Erreur génération lien WhatsApp:", err);
            setError("Impossible de générer le lien. Réessayez.");
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        if (!expiresAt) return undefined;
        const update = () => setTimeRemaining(Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));
        const timer = setInterval(update, 1000);
        window.addEventListener('focus', update);
        document.addEventListener('visibilitychange', update);
        return () => {
            clearInterval(timer);
            window.removeEventListener('focus', update);
            document.removeEventListener('visibilitychange', update);
        };
    }, [expiresAt]);

    useEffect(() => {
        generateLink();
    }, [generateLink]);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    return {
        whatsappUrl,
        qrCodeBase64,
        linkingCode,
        loading,
        error,
        timeRemaining,
        isMobile,
        generateLink,
        formatTime,
    };
};

export default useWhatsAppLink;
